/**
 * Emoji-only-Erkennung für den WhatsApp-Mock. WhatsApp rendert Nachrichten, die
 * ausschliesslich aus bis zu drei Emoji-Clustern bestehen, gross und OHNE Bubble.
 *
 * Bewusst `\p{Extended_Pictographic}` und NICHT `\p{Emoji}`: `\p{Emoji}` ist true
 * für ASCII-Ziffern 0-9 sowie `#` und `*` — `"2"` wäre sonst „emoji-only".
 *
 * Bewusst akzeptierte Falsch-Positive: `\p{Extended_Pictographic}` umfasst auch
 * typografische Zeichen (`©`, `®`, `™`, `▪`, `‼️`, `〽️`). Eine Bubble, die nur
 * daraus besteht, wird gross gerendert — WhatsApp selbst tut das ebenfalls, und
 * in der Marketing-Copy existiert kein solcher Fall. Siehe Spec §4.2.
 */
const EMOJI_CLUSTER =
  '(?:' +
  // Flagge: zwei Regional Indicators (🇩🇪)
  '\\p{Regional_Indicator}\\p{Regional_Indicator}' +
  // Keycap: Ziffer/#/* + optionales VS16 + Combining Enclosing Keycap (1️⃣)
  '|[0-9#*]\\uFE0F?\\u20E3' +
  // Piktogramm + optional Skin-Tone-Modifier ODER Variation Selector,
  // beliebig oft per ZWJ verkettet (👍🏽, 👨‍👩‍👧‍👦, ❤️)
  '|\\p{Extended_Pictographic}(?:\\uFE0F|\\p{Emoji_Modifier})?' +
  '(?:\\u200D\\p{Extended_Pictographic}(?:\\uFE0F|\\p{Emoji_Modifier})?)*' +
  ')';

/** Ganzer String = nur Emoji-Cluster, optional durch Whitespace getrennt. */
const EMOJI_ONLY_RE = new RegExp(
  `^${EMOJI_CLUSTER}(?:\\s*${EMOJI_CLUSTER})*$`,
  'u',
);
const EMOJI_CLUSTER_RE = new RegExp(EMOJI_CLUSTER, 'gu');

/** WhatsApp vergrössert bis zu drei Emojis; ab vier bleibt es eine normale Bubble. */
export const EMOJI_ONLY_MAX = 3;

export function isEmojiOnlyText(text: unknown): text is string {
  if (typeof text !== 'string') return false;
  const trimmed = text.trim();
  if (trimmed === '') return false;
  if (!EMOJI_ONLY_RE.test(trimmed)) return false;
  // `String.prototype.matchAll` klont die RegExp intern → kein `lastIndex`-Leak
  // trotz `g`-Flag.
  const count = [...trimmed.matchAll(EMOJI_CLUSTER_RE)].length;
  return count >= 1 && count <= EMOJI_ONLY_MAX;
}
